<template>
  <div class="header-container white bg">
    <div class="header-info-container">
      <div v-if="showUpdateColumn" class="column-header update" label="Update">
        <help-tooltip type="info">
          Select "Y" to update each case or<br>
          select "N" to decline case update.
        </help-tooltip>
        &nbsp;
        Update
      </div>
      <div class="column-header name" label="Scenario Name" @click="updateSortBy('name')">
        Scenario Name
        <sort-indicator :active="sortBy.field === 'name'" :direction="sortBy.desc ? 'DESC' : 'ASC'" />
      </div>
      <div
        v-for="column in displayedColumns"
        :key="column.field"
        :class="`column-header ${column.class || '' } ${column.sortField ? 'sortable' : ''}`"
        :style="{flex: column.size}"
        @click="column.sortField && !state.columnEditOpened ? updateSortBy(column.sortField) : null"
      >
        <md-icon v-if="column.icon">
          {{ column.icon }}
        </md-icon>
        <span v-if="column.label">
          {{ column.label }}
        </span>
        <sort-indicator v-if="column.sortField && !state.columnEditOpened" :active="sortBy.field === column.sortField" :direction="sortBy.desc ? 'DESC' : 'ASC'" />
        <md-icon v-if="state.columnEditOpened" class="remove-column-icon" @click.native="toggleColumn(column)">close</md-icon>
      </div>
    </div>

    <md-icon 
      v-if="showFavorites"
      class="column-header favorite" 
      label="Favorite" 
      @click.native="updateSortBy('isFavorite')"
    >
      star
      <sort-indicator :active="sortBy.field === 'isFavorite'" :direction="sortBy.desc ? 'DESC' : 'ASC'" />
    </md-icon>

    <div v-if="showEditor" class="columns-edit-container">
      <md-menu
        :md-close-on-select="false"
        :md-close-on-click="false"
        :md-offset-y="10"
        :md-active="state.columnEditOpened"
        @md-opened="onColumnEditOpen"
        @md-closed="onColumnEditClose"
      >
        <md-button class="columns-edit-button" @click="toggleColumnEdit">
          <md-icon>table_chart</md-icon>
          <md-icon class="edit-icon">edit</md-icon>
        </md-button>

        <md-menu-content>
          <md-menu-item v-if="displayedColumns.length >= 4" class="max-columns-info">
            You can only have
            <br>4 columns displayed
            <br>Please remove
            <br>a column first
          </md-menu-item>
          <md-menu-item
            v-for="hiddenColumn in hiddenColumns"
            :key="hiddenColumn.field"
            :disabled="displayedColumns.length >= 4"
            @click="toggleColumn(hiddenColumn)"
          >
            {{ hiddenColumn.label }}
          </md-menu-item>
        </md-menu-content>
      </md-menu>
    </div>
  </div>
</template>

<script>
import without from 'lodash/without';

import SortIndicator from './SortIndicator.vue';
import HelpTooltip from '../HelpTooltip.vue';

import caseColumns from './caseColumns';

export default {
  name: 'header-row',
  components: { SortIndicator, HelpTooltip },
  props: {
    user: {
      type: Object,
      required: true
    },
    sortBy: {
      type: Object,
      required: true,
    },
    showFavorites: {
      type: Boolean,
      default: true,
    },
    showEditor: {
      type: Boolean,
      default: true,
    },
    displayedColumns: {
      type: Array,
      default: () => [],
    },
    showUpdateColumn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: {
        columnEditOpened: false,
      },
    }
  },
  computed: {
    hiddenColumns() {
      return without(caseColumns, ...this.displayedColumns);
    },
  },
  methods: {
    updateSortBy(field) {
      this.$emit('updateSortBy', field);
    },
    toggleColumn(column) {
      if (!this.displayedColumns.includes(column)) {
        if (this.displayedColumns.length >= 4) {
          return;
        }
        this.$emit('updateDisplayedColumns', this.displayedColumns.concat(column));
      } else {
        this.$emit('updateDisplayedColumns', without(this.displayedColumns, column));
      }
    },
    toggleColumnEdit() {
      this.state.columnEditOpened = !this.state.columnEditOpened;
    },
    onColumnEditOpen() {
      this.state.columnEditOpened = true;
    },
    onColumnEditClose() {
      this.state.columnEditOpened = false;
    },
  },
}
</script>

<style scoped>
.header-container {
  width: 100%;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 18px;
  text-align: left;
  border-bottom: 1px solid #2B2B2B;
  height: 100%;
}

.column-header.update {
  justify-content: center;
  min-width: 100px;
}

.column-header.name {
  margin-left: 20px;
  flex: 2;
}

.header-info-container {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  min-width: 0;
  flex: 1 1 auto;
}

.column-header {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-basis: 0;
  width: 0;
}

.column-header.patient {
  text-align: center;
}

.column-header.sortable {
  cursor: pointer;
}

.column-header.favorite {
  color: #2B2B2B !important;
  font-size: 24px !important;
  width: 40px;
  min-width: 40px;
  margin: 0 10px 0 0;
}

.columns-edit-container {
  background-color: #0870b0;
  align-self: stretch;
  display: flex;
  align-items: center;
  width: 40px;
}

.columns-edit-container .md-icon {
  color: #fff;
}

.columns-edit-button {
  position: relative;
  cursor: pointer;
  min-width: 0;
}

.columns-edit-container .edit-icon {
  position: absolute;
  right: -6px;
  bottom: -3px;
  width: 16px;
  height: 16px;
  font-size: 16px !important;
  min-width: 16px;
}

.remove-column-icon {
  cursor: pointer;
  margin: 0;
}

.max-columns-info {
  background-color: #262736;
}
.max-columns-info >>> .md-list-item-content {
  color: #a9b3bc;
}
</style>
